/**
 * hexToRGB - converts hex colors including shorthand with or without pound to rgba.
 * @hex color to convert
 * @alpha (optional) opacity, defaults to 1.
 */
export const hexToRGB = (hex: string, alpha = 1) => {
  let newHex: string = hex;

  if (hex.startsWith('#') && hex.length === 7) {
    newHex = hex.slice(1, 7);
  } else if (hex.startsWith('#') && hex.length === 4) {
    newHex = hex.slice(1, 4);

    let expandedShorthandHex = '';
    newHex.split('').forEach(letter => {
      expandedShorthandHex += letter.repeat(2);
      return expandedShorthandHex;
    });
    newHex = expandedShorthandHex;
  }

  if (newHex.toString().length !== 6) {
    return hex;
  }
  const r: number = parseInt(newHex.slice(0, 2), 16);
  const g: number = parseInt(newHex.slice(2, 4), 16);
  const b: number = parseInt(newHex.slice(4, 6), 16);

  // eslint-disable-next-line
  if (isNaN(r) || isNaN(g) || isNaN(b)) {
    return hex;
  }
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
